// extracted by mini-css-extract-plugin
export default {"introParagraph":"Features_introParagraph__B-qex"};